module.exports = __webpack_public_path__ + "img/3D_Face_Center.a733d592.gif";